import { Routes } from '@angular/router';
import { riskManagerGuard } from '@core/guards/risk-manager.guard';

export const companyRoutes: Routes = [
  {
    path: 'cix-auth/callback',
    loadComponent: () => import('@features/companies/cix-auth-callback/cix-auth-callback.component').then(m => m.CixAuthCallbackComponent),
  },
  {
    path: 'companies',
    loadComponent: () => import('./companies.component').then(m => m.CompaniesComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'companies/new',
    loadComponent: () => import('./new-company/new-company.component').then(m => m.NewCompanyComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'companies-match',
    loadComponent: () => import('./company-match/company-match.component').then(m => m.CompanyMatchComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'companies/bulk-upload',
    loadComponent: () => import('./bulk-upload/company-bulk-upload.component').then(m => m.CompanyBulkUploadComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'companies/bulk-deactivate',
    loadComponent: () => import('./bulk-deactivation/company-bulk-deactivation.component').then(m => m.CompanyBulkDeactivationComponent),
    canActivate: [riskManagerGuard],
  },
];
